import EventDetailsPrint from "../events/EventDetailsPrint";

export default function BidPrintView() {
  return <EventDetailsPrint mode="bid" />;
}
